export const availableLanguages = [
    {
        id: "fr",
        label: "FR"
    },
    {
        id: "en",
        label: "EN"
    }
];
